<!-- Loading State -->
<div *ngIf="loading" class="loading-container">
    <div class="loading-content">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="loading-text">Cargando operadoras...</p>
    </div>
</div>

<!-- Error State -->
<div *ngIf="error && !loading" class="error-container">
    <div class="error-content">
        <i class="fas fa-exclamation-triangle error-icon"></i>
        <h5 class="error-title">Error al cargar operadoras</h5>
        <p class="error-message">{{ error }}</p>
        <button type="button" class="btn btn-primary btn-sm" (click)="onRetry()">
            <i class="fas fa-redo me-2"></i>Reintentar
        </button>
    </div>
</div>

<!-- Empty State -->
<div *ngIf="!loading && !error && operadoras.length === 0" class="empty-container">
    <div class="empty-content">
        <i class="fas fa-mobile-alt empty-icon"></i>
        <h5 class="empty-title">No hay operadoras disponibles</h5>
        <p class="empty-message">No se encontraron operadoras activas en el sistema.</p>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="onRetry()">
            <i class="fas fa-redo me-2"></i>Actualizar
        </button>
    </div>
</div>

<!-- Success State - Lista de Operadoras -->
<div *ngIf="!loading && !error && operadoras.length > 0" class="operadoras-container">
    
    <!-- Header -->
    <div class="operadoras-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h6 class="header-title">
                    <i class="fas fa-sim-card me-2"></i>Seleccionar Operadora
                </h6>
                <p class="header-subtitle">
                    Seleccione la operadora móvil para configurar recargas
                </p>
            </div>
            <div class="header-actions d-flex align-items-center gap-2">
                <span class="badge bg-primary">{{ operadoras.length }} operadoras</span>
                <button type="button" 
                        class="btn btn-outline-warning btn-sm"
                        (click)="navigateToAdmin()"
                        title="Administrar operadoras, tipos y productos">
                    <i class="fas fa-cogs me-1"></i>Administrar
                </button>
            </div>
        </div>
    </div>

    <!-- Grid de Operadoras -->
    <div class="operadoras-grid">
        <div *ngFor="let operadora of operadoras; trackBy: trackByCode" 
             class="operadora-card" 
             (click)="onSelectOperadora(operadora)"
             [attr.data-code]="operadora.code">
            
            <!-- Logo de la operadora -->
            <div class="operadora-logo">
                <img [src]="operadora.urlImag || '/assets/brandLogos/default.svg'" 
                     [alt]="operadora.name"
                     (error)="onImageError($event)"
                     class="logo-image">
            </div>

            <!-- Información de la operadora -->
            <div class="operadora-info">
                <h5 class="operadora-name">{{ operadora.name }}</h5>
                <p class="operadora-description">{{ operadora.description }}</p>
                
                <!-- Estados -->
                <div class="operadora-status">
                    <span class="status-badge status-active" *ngIf="operadora.status">
                        <i class="fas fa-check-circle me-1"></i>Activa
                    </span>
                </div>
            </div>

            <!-- Indicador de navegación -->
            <div class="operadora-arrow">
                <i class="fas fa-chevron-right"></i>
            </div>

            <!-- Overlay de hover -->
            <div class="card-overlay"></div>
        </div>
    </div>

    <!-- Footer con información adicional -->
    <div class="operadoras-footer">
        <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
                <i class="fas fa-info-circle me-1"></i>
                Haga clic en una operadora para ver los tipos de operación disponibles
            </small>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onRetry()">
                <i class="fas fa-sync-alt me-2"></i>Actualizar
            </button>
        </div>
    </div>
</div> 